(function (angular) {
    angular.module('bizPartEngage').controller('cleanbase.completeregister', completeRegister);

    completeRegister.$inject = ['$rootScope', '$scope', '$stateParams', 'core.completeregisterService', '$translate', '$timeout', '$filter', '$sce', 'core.users.service'];

    function completeRegister($rootScope, $scope, $stateParams, completeRegisterService, $translate, $timeout, $filter, $sce, userService) {
        var vm = this;

        vm.CompleteRegistrationGuid = $stateParams.guid;
        vm.Unauthorized = false;

        vm.MobilePattern = /^\+[0-9]{10,}$/;

        vm.GetUser = GetUser;
        vm.CompleteRegistration = CompleteRegistration;
        vm.GenderClick = GenderClick;
        vm.GetGender = GetGender;
        vm.IsMobileValid = IsMobileValid;
        vm.LoadTranslations = LoadTranslations;
        vm.GetPassword = GetPassword;
        vm.IsEmailValid = IsEmailValid;
        vm.SendVerificationCode = SendVerificationCode;
        vm.IsPasswordSecure = IsPasswordSecure;

        function IsEmailValid() {
            if (!vm.User || !vm.User.Email) return false;
            if (!vm.EmailPattern) return true;

            return vm.EmailPattern.test(vm.User.Email);
        }

        function SendVerificationCode() {
            if (vm.IsEmailValid()) {
                completeRegisterService.SendVerificationCode(vm.CompleteRegistrationGuid, vm.User.Email).then(SendVerificationCodeCallback, SendVerificationCodeError);
            } else {                
                vm.ShowEmailInvalid = true;
            }

            function SendVerificationCodeCallback(response) {
                var result = BizPartCoreHelpers.getResponseValue(response);
                if (result) {
                    vm.VerificationCodeSent = true;
                } else {
                    SendVerificationCodeError();
                }
            }

            function SendVerificationCodeError() {
                console.log("send verification code error");
            }
        }

        function IsMobileValid() {
            if (!vm.User.Mobile) return false;

            return vm.MobilePattern.test(vm.User.Mobile)
        }

        function GenderClick(gender) {
            for (var i = 0; i < vm.Genders.length; i++) {
                vm.Genders[i].checked = vm.Genders[i] === gender;
            }
        }

        function GetUser() {
            completeRegisterService.GetUserByActionGuid(vm.CompleteRegistrationGuid).then(GetUserByActionGuidCallback, HandleError);

            function GetUserByActionGuidCallback(response) {
                var result = BizPartCoreHelpers.getResponseValue(response);
                vm.User = result.User;
                vm.FormSettings = result.Settings;
                console.log("formsettings", vm.FormSettings);
                vm.Initialized = true;
            }

            function HandleError(response) {                
                if (response.status === 401) {
                    vm.Unauthorized = true;
                    vm.UnauthorizedMessage = BizPartCoreHelpers.getResponseValue(response);
                }
            }
        }

        function GetGender() {
            for (var i = 0; i < vm.Genders.length; i++) {
                if (vm.Genders[i].checked) {
                    return vm.Genders[i].SystemName;
                }
            }
            return null;
        }

        function IsPasswordSecure() {
            return !vm.GetPassword || $rootScope.PasswordRegex.test(vm.Password);
        }

        function GetPassword() {
            if (vm.IsPasswordSecure() && vm.Password && vm.Password === vm.RepeatPassword) {
                return vm.Password;
            } 
        }

        function CompleteRegistration() {            
        
            var gender = vm.GetGender();

            var password;
            var passwordValid = true;
            if (vm.FormSettings && vm.FormSettings.AllowSetPassword) {
                password = vm.GetPassword();
                if (!password) {
                    passwordValid = false;
                }
            }            
            
            if (vm.MyForm.$valid && gender && passwordValid && !vm.Submitting && !vm.Submitted) {
                console.log("submitted");
                vm.ShowValidation = false;
                vm.Submitting = true;

                vm.User.Gender = gender;                

                completeRegisterService.CompleteRegistration(vm.CompleteRegistrationGuid, vm.User, password, vm.ExtCustomFieldValues, vm.VerificationCode).then(CompleteRegistrationCallback, HandleError);

                function CompleteRegistrationCallback(response) {
                    var result = BizPartCoreHelpers.getResponseValue(response);
                    console.log("result", result);
                    vm.Submitted = true;
                    vm.Success = result.Success;
                    if (!vm.Success) {
                        vm.Message = $sce.trustAsHtml(result.Message);
                    } else {
                        vm.SuccessMessage = $sce.trustAsHtml(result.Message)
                        var redirectUrl = result.ExtraInfo.RedirectUrl;
                        if (redirectUrl) {
                            if (redirectUrl.startsWith('/') && redirectUrl.toLowerCase().indexOf('login') < 0) {
                                setSessionStorage('highlightLogin', 'true');
                            }

                            vm.RedirectTimeout = $timeout(() => {
                                location.href = $filter('siteroot')(redirectUrl);
                            }, 20000);
                        }
                    }
                }

                function HandleError() {
                    console.log("handle error");
                    vm.Success = false;
                    vm.Submitted = true;
                    vm.InternalError = true;
                    vm.Message = "Something went wrong, please try again later."
                }
            } else {
                console.log("not valid");
                vm.ShowValidation = true;
            }
            
        }

        function LoadTranslations() {
            $translate([
                'CORE.COMPLETEREGISTER.ERROR_MSG',
                'CORE.COMPLETEREGISTER.MAILTO'                

            ]).then(function (translations) {
                                
                var msg = translations['CORE.COMPLETEREGISTER.ERROR_MSG']?.toString();
                var mail = translations['CORE.COMPLETEREGISTER.MAILTO']?.toString();
                if (msg && mail) {
                    vm.ErrorMessage = msg.replace('##MAILTOLINK##', '<a href="mailto:' + mail + '">' + mail + '</a>');
                } else {
                    vm.ErrorMessage = msg;
                }
                console.log("error msg", vm.ErrorMessage);
                
            });
        }

        function Init() {
            
            userService.GetGenders().then(GetGendersCallback);
            vm.LoadTranslations();
            completeRegisterService.GetGuidInfo(vm.CompleteRegistrationGuid).then(GetGuidInfoCallback, HandleError);

            function GetGuidInfoCallback(response) {
                var result = BizPartCoreHelpers.getResponseValue(response);
                console.log("GetGuidInfoCallback", result);
                if (result.Type === 'COMPLETE_REGISTRATION') {
                    vm.GetUser();
                } else if (result.Type === 'CREATE_USER_FOR_UNIT') {
                    vm.CreateUserForUnit = true;
                    vm.FormSettings = result.Settings;

                    if (vm.FormSettings.AllowEmailDomains && vm.FormSettings.AllowEmailDomains.length > 0) {
                        var regexDomains = vm.FormSettings.AllowEmailDomains.join('|');
                        //vm.EmailPattern = new RegExp("^\\w+([-+.']\\w+)*@(?=(?:" + regexDomains + ")\\.\\w+$)\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$");
                        vm.EmailPattern = new RegExp("^[a-zA-Z0-9._%+-]+@(?:" + regexDomains + ")$");
                    }        

                    vm.Initialized = true;
                }
            }       

            function HandleError(response) {
                if (response.status === 401) {
                    vm.Unauthorized = true;
                    vm.UnauthorizedMessage = BizPartCoreHelpers.getResponseValue(response);
                }
            }

            function GetGendersCallback(response) {
                vm.Genders = BizPartCoreHelpers.getResponseValue(response);
            }

            $scope.$on("$destroy", () => {
                if (vm.RedirectTimeout) {
                    $timeout.cancel(vm.RedirectTimeout);
                }
            });
        }

        vm.$onInit = Init;

    }
})(window.angular);